<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="活动名称" style="width: 25%;">
              <el-input v-model="q.activityName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="销售公司" style="width: 25%;">
              <el-input v-model="q.saleGroup" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="创建时间" style="width: 50%;">
              <el-date-picker
                  v-model="valueTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
              />
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.9rem;"
                       @click="toNew">新增活动
            </el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            max-height="450"
        >
          <el-table-column
              label="活动名称"
              prop="activityName"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="活动描述"
              prop="activityDescription"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="销售公司名称"
              prop="saleGroup"
              width="220"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="销售公司编码"
              prop="saleGroupCode"
              width="110"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="促销开始时间"
              prop="startTime"
              width="150"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="促销结束时间"
              prop="endTime"
              width="150"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="创建人"
              prop="createUserName"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="创建时间"
              prop="createTime"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="修改人"
              prop="updateUserName"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="修改时间"
              prop="lastUpdateTime"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="175">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="toDetail(scope.row)">
                查看
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="toChange(scope.row)">
                修改
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="toDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button type="primary" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import salesPromotion from '@/api/salesPromotion'
import updownfile from "@/utils/updownfile";
export default {
  data() {
    return {
      q:{
        activityName:'',
        saleGroup: '',
        createTimeStart:'',
        createTimeEnd:'',
        pageNo:1,
        pageSize: 10,
        total: 0
      },
      valueTime: [],
      tableData: []
    }
  },
  methods:{
    changeTime(date){
      if(date){
        this.q.createTimeStart = date[0];
        this.q.createTimeEnd = date[1];
      }
    },
    handleFilter(){
      this.q.pageNo = 1
      this.query()
    },
    resetData(){
      this.q = {
        pageNo: 1,
        pageSize: 10
      }
      this.valueTime = []
      this.query()
    },
    exportExcel(){
      updownfile.down("/api/swyl/v1/demo/bscPromotionActivities/downloadActivitiesExcel",this.q, "get", 'data');
    },
    query(){
      salesPromotion.selectActivitiesPage(this.q).then(res=>{
        this.tableData = res.records;
        this.q.total = res.total;
      })
    },
    //添加活动
    toNew(){
      this.$router.push({
        path: '/salesPromotionList/addNewActivites',
        query:{
          type: 'add'
        }
      })
    },
    //查看
    toDetail(row){
      this.$router.push({
        path: '/salesPromotionList/seeActivites',
        query:{
          id: row.id
        }
      })
    },
    //修改
    toChange(row){
      this.$router.push({
        path: '/salesPromotionList/addNewActivites',
        query:{
          type: 'update',
          id: row.id
        }
      })
    },
    //删除
    toDelete(row){
      this.$confirm('确定删除该数据,删除后不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        salesPromotion.deleteActivitiesByIds([row.id]).then(res=>{
          if(res.f){
            this.query()
          }
        })
      }).catch(() => {
      });
    }
  },
  created() {
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style lang="less" scoped>

</style>